(function () {
  'use strict';

  const COLOR_NAMES = ['black', 'brown', 'tobacco'];

  function normalize(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function getSelectedColor() {
    /*
     * Horizon variant buttons contain:
     * data-option-name="Color"
     * value="Black"
     */

    const inputs = document.querySelectorAll(
      'input[type="radio"][data-option-name]'
    );

    for (const input of inputs) {
      const optionName = normalize(
        input.getAttribute('data-option-name')
      );

      if (
        optionName === 'color' &&
        input.checked
      ) {
        return normalize(input.value);
      }
    }

    /*
     * Fallback for select-based variant pickers.
     */

    const selects = document.querySelectorAll('select');

    for (const select of selects) {
      const optionName =
        normalize(select.name) ||
        normalize(select.getAttribute('data-option-name'));

      if (optionName.includes('color')) {
        return normalize(select.value);
      }
    }

    return null;
  }

  function getMediaColor(media) {
    /*
     * Horizon renders the product media image with
     * its Shopify media alt text.
     */

    const image = media.querySelector('img');

    if (!image) {
      return null;
    }

    return normalize(
      image.getAttribute('alt')
    );
  }

  function applyColorFilter() {
    const selectedColor = getSelectedColor();

    if (!selectedColor) {
      return;
    }

    if (!COLOR_NAMES.includes(selectedColor)) {
      return;
    }

    const gallery = document.querySelector(
      'media-gallery'
    );

    if (!gallery) {
      return;
    }

    /*
     * Main gallery slides
     */
    const slides = gallery.querySelectorAll(
      'slideshow-slide'
    );

    slides.forEach(function (slide) {
      const media = slide.querySelector(
        '.product-media'
      );

      if (!media) {
        return;
      }

      const imageColor = getMediaColor(media);

      if (!imageColor) {
        /*
         * Images without a color tag are treated as common
         * images and remain visible.
         */
        slide.style.display = '';
        slide.hidden = false;
        return;
      }

      const shouldShow =
        imageColor === selectedColor;

      slide.style.display =
        shouldShow ? '' : 'none';

      slide.hidden = !shouldShow;
    });

    /*
     * Desktop grid
     */
    const gridItems = gallery.querySelectorAll(
      '.media-gallery__grid > li'
    );

    gridItems.forEach(function (item) {
      const media = item.querySelector(
        '.product-media'
      );

      if (!media) {
        return;
      }

      const imageColor = getMediaColor(media);

      if (!imageColor) {
        item.style.display = '';
        item.hidden = false;
        return;
      }

      const shouldShow =
        imageColor === selectedColor;

      item.style.display =
        shouldShow ? '' : 'none';

      item.hidden = !shouldShow;
    });
  }

  function start() {
    applyColorFilter();

    /*
     * Variant selection in Horizon can update the gallery
     * without a complete page reload.
     */
    document.addEventListener(
      'change',
      function (event) {
        const target = event.target;

        if (
          target.matches(
            'input[type="radio"][data-option-name]'
          ) ||
          target.matches('select')
        ) {
          setTimeout(
            applyColorFilter,
            100
          );
        }
      }
    );

    /*
     * Watch for Horizon dynamically updating the gallery.
     */
    const observer =
      new MutationObserver(function () {
        setTimeout(
          applyColorFilter,
          50
        );
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();